<template>
  <v-row justify="center" no-gutters>
    <v-dialog
      v-model="open"
      persistent
      max-width="550px"
      @keydown="handleEvent"
      hide-overlay
    >
      <v-card dense class="unsavedChanges">
        <v-toolbar elevation="0">
          <v-toolbar-title class="pl-2 text--subtitle">
            <v-icon color="primary" style="padding-bottom: 2px"
              >mdi-play-circle-outline</v-icon
            >
            {{ $t('message.playerPage.exitWithoutSaving') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0">
          <v-row no-gutters>
            <v-col cols="12">
              <v-card-text class="pa-0">{{
                $t('message.playerPage.textConfirmChanges')
              }}</v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-8 pt-4 pb-6">
          <v-spacer></v-spacer>
          <v-btn class="mr-2 px-4" text @click="handleClose">
            {{ $t('message.playerPage.back') }}
          </v-btn>
          <v-btn color="primary" @click="discardChanges">
            {{ $t('message.playerPage.discardChanges') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'UnsavedChangesModal',
  components: {},
  data: () => ({
    open: false,
    isBtnPage: false,
    isQualityPage: false,
    isMiniTriggerPage: false,
    isPixelsPage: false,
    isEditDrm: false,
    indexTabDrm: undefined,
  }),
  watch: {},
  mounted() {
    this.$root.$on(
      'unsavedChangesModal',
      (
        isBtnPage,
        isQualityPage,
        isMiniTriggerPage,
        isPixelsPage,
        isEditDrm,
        indexTabDrm
      ) => {
        this.isQualityPage = isQualityPage
        this.isBtnPage = isBtnPage
        this.isMiniTriggerPage = isMiniTriggerPage
        this.isPixelsPage = isPixelsPage
        this.isEditDrm = isEditDrm
        this.open = true
        this.indexTabDrm = indexTabDrm
      }
    )
  },
  beforeDestroy() {
    this.$root.$off('unsavedChangesModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    ...mapActions('user', ['addUser', 'editUser', 'addFolder', 'editFolder']),
    discardChanges() {
      if (this.isBtnPage) {
        this.$root.$emit('discardChangesBtnPage')
        this.handleClose()
      } else if (this.isQualityPage) {
        this.$root.$emit('discardChangesQualityPage')
        this.open = false
      } else if (this.isMiniTriggerPage) {
        this.$root.$emit('discardChangesMiniTriggerPage')
      } else if (this.isPixelsPage) {
        this.$root.$emit('discardChangesPixelsPage')
        this.open = false
      } else if (this.isEditDrm && this.indexTabDrm) {
        this.$root.$emit('handleEditDrmTab', this.indexTabDrm)
        this.open = false
      } else if (this.isEditDrm) {
        this.$root.$emit('handleCloseDRM')
        this.open = false
      } else {
        this.$root.$emit('discardChanges')
        this.handleClose()
      }
    },
    handleClose() {
      if (this.isQualityPage) {
        this.$root.$emit('cancelDiscardQualityPage')
      }
      this.open = false
    },
    handleEvent(event) {
      const e = event
      if (e.key) {
        e.key === 'Escape' && this.handleClose()
      }
      return
    },
  },
}
</script>

<style></style>
